/**
 * abilityVfxTankMeshes — Shape dispatch for SPY-710 tank wave (OCP).
 */
import { buildFighterAbilityMesh } from './abilityVfxFighterMeshes.js';
import { buildDecisiveStrike } from './abilityVfxDecisiveStrike.js';
import { buildCourage } from './abilityVfxCourage.js';
import { buildJudgment } from './abilityVfxJudgment.js';
import { buildDemacianJustice } from './abilityVfxDemacianJustice.js';

const TANK_SHAPE_BUILDERS = {
  decisive_strike: buildDecisiveStrike,
  courage: buildCourage,
  judgment: buildJudgment,
  demacian_justice: buildDemacianJustice
};

/** @returns {object|null} */
export function buildTankAbilityMesh(THREE, spec) {
  const tankBuild = TANK_SHAPE_BUILDERS[spec?.shape];
  if (tankBuild) return tankBuild(THREE, spec);
  return buildFighterAbilityMesh(THREE, spec);
}
